import PropTypes from 'prop-types';
import { getPagePath, getResourcePath, trans } from '@spotahome/soyuz/client';
import classNames from 'classnames';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import LazyLoad from '../LazyLoad';

import './SupportCenter.scss';

const BACKGROUND_COLORS = { white: 'white', blue: 'blue' };

const PHOTO_OPTIONS = {
  white: 'agents-white',
  blueShort: 'agents-blue',
  blueLong: 'agents-blue-long'
};

const FONT_SIZE = {
  medium: 'medium',
  small: 'small'
};

const TARGETS = {
  helpCenter: 'externals.help-center',
  support: 'support'
};

const SupportCenter = ({
  backgroundColor = BACKGROUND_COLORS.blue,
  photo = PHOTO_OPTIONS.white,
  fontSize = FONT_SIZE.small,
  target = TARGETS.helpCenter
}) => {
  const classes = classNames('support-center', {
    'support-center--blue': backgroundColor === BACKGROUND_COLORS.blue,
    'support-center--white': backgroundColor === BACKGROUND_COLORS.white,
    'support-center--medium-font': fontSize === FONT_SIZE.medium
  });

  const onClick = () =>
    SoyuzAnalytics.sendGA4Event('open', {
      context: 'support-center',
      section: target
    });

  return (
    <LazyLoad offset={150} once>
      <a className={classes} href={getPagePath(target)} onClick={onClick}>
        <img
          src={getResourcePath(
            `/images/contact-us/${PHOTO_OPTIONS[photo]}.png`
          )}
          alt={trans('support.center')}
        />
        <span>{trans('support.center')}</span>
      </a>
    </LazyLoad>
  );
};

SupportCenter.propTypes = {
  backgroundColor: PropTypes.oneOf(Object.keys(BACKGROUND_COLORS)),
  photo: PropTypes.oneOf(Object.keys(PHOTO_OPTIONS)),
  fontSize: PropTypes.oneOf(Object.keys(FONT_SIZE)),
  target: PropTypes.oneOf(Object.keys(TARGETS))
};

export default SupportCenter;
